export class DocumentTrainingViewModel {
  DocumentNumber: string;
  NameTraining: string;
  DocumentName: string;
  Status: boolean;
  UrlDocumentFormat: string;
}
